import {
  SlDivider
} from "./chunk.5ZSXZIE6.js";

// src/components/divider/divider.ts
var divider_default = SlDivider;
SlDivider.define("sl-divider");

export {
  divider_default
};
